export const MODULES = [
  'users',
  'templates',
  'profile',
  'company',
  'briefcase',
  'web',
];